import { ValueChainApp } from '@/components/value-chain/ValueChainApp';

export function ValueChainPage() {
  return <ValueChainApp />;
}
